import {isWebviewApp, isWebviewBuild} from "./utils/config.utils";
import {webviewAppIds} from "./utils/webview";

window.clientConfig.features = {};

window.clientConfig.features.isSupportGetUserIds =
  (isWebviewApp(webviewAppIds.toonme) && isWebviewBuild(634, 1751))
  || (isWebviewApp(webviewAppIds.newprofilepic) && isWebviewBuild(108, 317))
  || (isWebviewApp(webviewAppIds.photolabFree) && isWebviewBuild(8197, 10543));

window.clientConfig.features.isSupportInApp =
  (isWebviewApp(webviewAppIds.toonme) && isWebviewBuild(0, 1822))
  || (isWebviewApp(webviewAppIds.photolabFree) && isWebviewBuild(0, 10759));

window.clientConfig.features.isSupportRewardedAd =
  (isWebviewApp(webviewAppIds.toonme) && isWebviewBuild(655, 1823))
  || (isWebviewApp(webviewAppIds.photolabFree) && isWebviewBuild(8317, 10777));

window.clientConfig.features.isSubscribeModel = true;
window.clientConfig.features.isPurchaseModel = false;
window.clientConfig.features.isRewardedAdModel = false;

if (window.clientConfig.isPro) {
  window.clientConfig.features.isSubscribeModel = true;
  window.clientConfig.features.isPurchaseModel = false;
  window.clientConfig.features.isRewardedAdModel = false;
}

window.clientConfig.features.freeCreativesAmount = 5;
window.clientConfig.features.hideWatermarkByDefault = window.clientConfig.isPro;

// может ли юзер из платного траффика процессить
window.clientConfig.features.paidTrafficUserDenyProcessing = false;

if (isWebviewApp(webviewAppIds.photolabFree)) {
  if (window.clientConfig.isWebviewAndroid) {
    window.clientConfig.features.rewardedAdUnitId = "ca-app-pub-8698123149353813/5230820348";
  } else {
    window.clientConfig.features.rewardedAdUnitId = "ca-app-pub-8698123149353813/4808433924";
  }
} else if (isWebviewApp(webviewAppIds.toonme)) {
  if (window.clientConfig.isWebviewAndroid) {
    window.clientConfig.features.rewardedAdUnitId = "ca-app-pub-8698123149353813/6843284916";
  } else {
    window.clientConfig.features.rewardedAdUnitId = "ca-app-pub-8698123149353813/1179894699";
  }
}
